import { addBusinessDays, isAfter, isEqual, isWeekend } from 'date-fns'

import { getUtcDate } from '../../../util/get-utc-date'
import { ValidatorRules } from '../../../util/validator'
import { FundingSource, TermsStepState } from './terms-slice'

export const termsRules: ValidatorRules<TermsStepState> = {
  fundingSource: [
    (state: TermsStepState) => ({
      isValid: state.terms.fundingSource !== FundingSource.Unknown,
      message: 'Please select the funding type of the trade'
    })
  ],
  investment: [
    (state: TermsStepState) => ({
      isValid:
        (state.terms.fundingSource !== FundingSource.Unknown &&
          state.terms.fundingSource !== FundingSource.Cash) ||
        Number(state.terms.investment) >= state.minimumInvestmentAmount,
      message: `The amount must be at least R${state.minimumInvestmentAmount.toLocaleString(
        'en-GB'
      )}`
    })
  ],
  switchInvestment: [
    (state: TermsStepState) => ({
      isValid:
        (state.terms.fundingSource !== FundingSource.Unknown &&
          state.terms.fundingSource !== FundingSource.Switch) ||
        state.terms.fullSwitch ||
        (Number(state.terms.switchInvestment) >= state.minimumInvestmentAmount &&
          state.terms.switchTrade &&
          Number(state.terms.switchInvestment) <= state.terms.switchTrade.accountValue * 0.95),
      message: `The amount must be in the range`
    })
  ],
  switchTrade: [
    (state: TermsStepState) => ({
      isValid:
        (state.terms.fundingSource !== FundingSource.Unknown &&
          state.terms.fundingSource !== FundingSource.Switch) ||
        Boolean(state.terms.switchTrade),
      message: `A originating trade is required`
    })
  ],
  accountName: [
    (state: TermsStepState) => ({
      isValid: !!state.terms.accountName,
      message: 'You have to give the trade a name'
    })
  ],
  requestedStartDate: [
    (state: TermsStepState) => {
      if (!state.terms.requestedStartDate) {
        return {
          isValid: true
        }
      }

      const startDate = getUtcDate(new Date(state.terms.requestedStartDate))
      const today = getUtcDate(new Date())
      const nextWorkingDay = addBusinessDays(today, 1)
      const isValid = isEqual(startDate, nextWorkingDay) || isAfter(startDate, nextWorkingDay)

      return {
        isValid,
        message: 'The requested start date must be at least the next working day'
      }
    },
    (state: TermsStepState) => {
      if (!state.terms.requestedStartDate) {
        return {
          isValid: true
        }
      }

      const startDate = getUtcDate(new Date(state.terms.requestedStartDate))
      const isValid = !isWeekend(startDate)

      return {
        isValid,
        message: 'The requested start date must be a week day'
      }
    }
  ]
}
